import { render, staticRenderFns } from "./SsoDetail.vue?vue&type=template&id=13748f65&scoped=true"
import script from "./SsoDetail.vue?vue&type=script&lang=js"
export * from "./SsoDetail.vue?vue&type=script&lang=js"
import style0 from "./SsoDetail.vue?vue&type=style&index=0&id=13748f65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13748f65",
  null
  
)

export default component.exports